export class Prescriber {
	readonly id: string;
	name: string;
	phone: string;
	email: string;
	professionalProof: string;
	recaptchaToken: string;

	constructor(
		options: {
			id?: string;
			name?: string;
			phone?: string;
			email?: string;
			professionalProof?: string;
		} = {}
	) {
		this.id = options.id || null;
		this.name = options.name || '';
		this.phone = options.phone || '';
		this.email = options.email || '';
		this.professionalProof = options.professionalProof || '';
	}
}
